/**
 *  Campaigns mutations module file
**/

import { MUTATIONS } from './constants'
import { state as initialState } from './state'

export const mutations = {
  [MUTATIONS.SET_META] (state, meta) {
    state.meta = { ...state.meta, ...meta }
  },
  [MUTATIONS.SET_CAMPAIGNS_COMPARE] (state, campaigns) {
    state.campaings_compare = [...campaigns]
  },
  [MUTATIONS.SET_COPY_TASKS] (state, payload) {
    state.copy_tasks = { ...state.copy_tasks, ...payload }
  },
  [MUTATIONS.SET_COPY_TASKS_LOADING] (state, flag) {
    state.copy_tasks.meta.loading = flag
  },
  [MUTATIONS.CLEAR_COPY_TASKS] (state) {
    state.copy_tasks = { ...initialState.copy_tasks }
  }
}
